// extracted by mini-css-extract-plugin
export var cartContainer = "_o1-4";
export var gray = "_o1-1";
export var itemContainer = "_o1-2";
export var itemDetails = "_o1-3";
export var strong = "_o1-0";